<template>
    <main>
        <div class="invitation" :class="[is_offline ? 'offline' : '']">
            <img class="kv" v-if="!is_offline" src="@/assets/image/2026/mobile/edm-banner.png" alt="">
            <img class="kv" v-else-if="cityCode" :src="offlineBanner" alt="">
            <img class="kv" v-else src="@/assets/image/2026/mobile/edm-banner-xianxia.png" alt="">
            <div class="content-wrap">
                <div class="content">
                    <div class="gift-content">
                        <img class="gift" src="@/assets/image/2026/mobile/edm-bj-xianshang.png" alt="" />
                    </div>
                    <img class="agenda-img" style="margin-top: .3rem;" src="@/assets/image/2026/mobile/edm-agenda.png" alt=""/>
                     <div class="btn-box">
                        <img src="@/assets/image/2026/mobile/edm-btn.png" alt="">
                        <div class="btn-wrap">
                            <div class="cen">
                                <img class="btn" v-if="!user_info.id" :src="staticNew('btn.png')" alt=""
                                    @click="toRegister">
                                <img class="btn" v-else :src="staticNew('btn2.png')" alt="">
                            </div>
                        </div>
                    </div>
                    <img class="logo-img" style="margin-top: .7rem; width: 50%;" src="@/assets/image/2026/mobile/edm-sponsor-logo.png" alt=""/>
                </div>
            </div>
        </div>
        <div class="book-success" v-if="book_success">
            <div class="mark"></div>
            <div class="content" v-scroll-lock="true">
                <div class="close" @click="book_success = false"></div>
                <div class="middle">
                    <div class="title">您已报名成功！</div>
                    <div class="btn" @click="util.toLink('/')">确定</div>
                </div>
            </div>
        </div>
        <div class="epidemic-tip" v-if="show_epidemic">
            <div class="mark"></div>
            <div class="content">
                <div class="con"></div>
                <div class="close" @click="show_epidemic = false"></div>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: 'invitation',
    data() {
        return {
            query: "",
            book_success: false,
            show_epidemic: true,
        }
    },
    components: {},
    computed: {
        user_info() {
            // if(this.$store.state.user_info.id){
            //     this.util.toLink('/');
            // }
            return this.$store.state.user_info;
        },
        is_offline() {
            return this.util.isOffline();
        },
        channel() {
            return this.tool.storage.getLocal('channel') || ""
        },
        cityCode() {
            var channel = this.channel || "";
            if (channel.indexOf('bj-offline') !== -1) return 'bj';
            if (channel.indexOf('gz-offline') !== -1) return 'gz';
            if (channel.indexOf('qd-offline') !== -1) return 'qd';
            return '';
        },
        offlineBanner() {
            return require('@/assets/image/2026/mobile/edm-banner-xianxia-' + this.cityCode + '.png');
        }
    },
    methods: {
        static(src) {
            return require('@/assets/edm/wap/' + src);
        },
        staticNew(src) {
            return require('@/assets/image/2024/mobile/' + src);
        },
        toRegister() {
            // var channel = this.tool.other.getUrlParams('channel') || '';
            // var url = window.location.origin+"?params";
            // if(channel){
            //     url = url + "&channel="+channel;
            // }
            // url = url+"#/registration";
            // window.location.href = url;
            this.$router.push('/registration')
        },
        checkChannel() {
            var channel = this.tool.storage.getLocal('channel');
            if (channel == 'sales-internal') {
                if (this.util.isOffline()) {
                    window.location.href = "http://s-event.cn/EDM/dell/211110/belowTheLine.html"
                } else {
                    window.location.href = "http://s-event.cn/EDM/dell/211110/onLine.html"
                }
            }
        }
    },
    mounted() {
        this.checkChannel();
        this.query = this.$route.query;
        if (this.user_info.id && this.tool.storage.getCookie('edm_login_tip') != 1) {
            //this.book_success = true;
            this.tool.storage.setCookie('edm_login_tip', 1, 365 * 10)
        }
        document.title = "大会信息丨2026戴尔科技峰会-新·生万物 数实新格局-戴尔(Dell)企业采购网";
        // if(this.is_offline){
        //   document.title = "大会信息丨2026戴尔科技峰会-新·生万物 数实新格局-戴尔(Dell)企业采购网"
        // }else{
        //   document.title = "2026 戴尔科技峰会";
        // }
    }
}
</script>

<style lang="scss" type="text/scss" scoped>
.invitation {
    background-color: #175cc6;

    .kv {
        width: 100%;
        display: block;
    }

    .content-wrap {
        background: url("~@/assets/image/2026/mobile/edm-bj.png") no-repeat top center;
        background-size: 100% 100%;
        padding: .3rem;
    }

    .content {
        padding-bottom: .5rem;
    }

    .content img {
        width: 100%;
        display: block;
        pointer-events: none;
    }

    .content .btn-box {
        position: relative;
    }

    .content .btn-box {
        position: relative;
        margin-top: .3rem;

        .btn-wrap {
            position: absolute;
            bottom: .3rem;
            right: .4rem;

            .cen {
                display: inline-block;

                img {
                    pointer-events: auto;
                }

                .btn {
                    float: left;
                    width: 1.8rem;
                    height: .5rem;
                    background-size: 100% 100%;
                }

                .btn:nth-last-child(1) {
                    margin-right: 0;
                }
            }
        }
    }

    .gift-content {
        position: relative;

        .btn {
            position: absolute;
            width: 100px;
            height: 36px;
            bottom: -20px;
            left: 50%;
            transform: translateX(-50%);
            background: url("~@/assets/edm/wap/btn2.png") no-repeat center center;
            background-size: contain;
            cursor: pointer;
        }

        .btn.hidden {
            background-image: url("~@/assets/edm/wap/btn2_2.png");
            background-size: contain;
        }
    }
}

.book-success {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;

    .mark {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, .8);
    }

    .content {
        position: absolute;
        left: 50%;
        top: 50%;
        width: 6.9rem;
        height: 4rem;
        background: url("~@/assets/image/2025/bg-success.png") no-repeat center center;
        background-size: cover;
        color: #fff;
        transform: translate(-50%, -50%);
        border-radius: .1rem;

        .close {
            width: .5rem;
            height: .5rem;
            position: absolute;
            top: 0;
            right: 0;
            background: url("~@/assets/image/54.png") no-repeat center center;
            background-size: .25rem;
            cursor: pointer;
            transition: background .3s ease;
        }

        .middle {
            width: 6.9rem;
            height: 4rem;
            text-align: center;
            color: #232846;

            .title {
                font-size: .4rem;
            }

            .m-title {
                font-size: .3rem;
                margin-top: .4rem;
                line-height: .5rem;
            }

            .btn {
                width: 2rem;
                height: .66rem;
                text-align: center;
                line-height: .66rem;
                color: #fff;
                background: #ec6014;
                margin: .8rem auto 0;
                border-radius: .1rem;
            }
        }
    }
}

.epidemic-tip {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    display: none;

    .mark {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.7)
    }

    .content {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        .con {
            width: 6.5rem;
            height: 8rem;
            background: url("~@/assets/edm/in2.jpg") no-repeat center center;
            background-size: contain;
            margin: 0 auto;
        }

        .close {
            width: .7rem;
            height: .7rem;
            margin: .5rem auto 0;
            background: url("~@/assets/edm/close.png") no-repeat center center;
            background-size: contain;
            cursor: pointer;
        }
    }
}
</style>
